import { render } from "./SupportExtensionsPopup.vue?vue&type=template&id=5f0bf2c3"
import script from "./SupportExtensionsPopup.vue?vue&type=script&lang=js"
export * from "./SupportExtensionsPopup.vue?vue&type=script&lang=js"

import "./SupportExtensionsPopup.vue?vue&type=style&index=0&id=5f0bf2c3&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__